 

// // import { useState } from 'react';
// // import Breadcrumb from '@components/Shared/Breadcrumb';
// // import { Card, CardBody } from '@components/card/card';
// // import { useTranslation } from 'react-i18next';
// // import { Link } from 'react-router-dom';
// // import ModalComponent from '@components/Modal/ModalComponent';
// // import Add from './Add';
// // import Loading from '@components/Shared/Loader/Loading';
// // import Update from './Update';
// // import NtxTable from '@components/DataTable/NtxTable';
// // import useGetAttributeList from '@hooks/INV/Attributes/useGetAttributeList';
// // import AttributeItems from './AttributeItems';
// // import { usePermissions } from '@Helper/Permisstions/usePermissions';

// // const Index = () => {
// //   const { HasPermission } = usePermissions();

// //   const [attribute, setAttribute] = useState<any>();
// //   const { t, i18n } = useTranslation();
// //   const { AttributesList, error, loading } = useGetAttributeList();

// //   const columns = [
// //     { title: t('Name'), key: 'name' },
// //     { title: t('Type'), key: 'type' },
// //     { title: t('Description'), key: 'description' },
// //     { title: '', key: 'action', className: 'text-end', sortable: false }
// //   ];

// //   const tableData = AttributesList?.map(item => {
// //     let typeIcon;
// //     let typeName;

// //     if (item.attType === 'Multi_Select') {
// //       typeIcon = <i className='fas fa-check-square text-primary'></i>;
// //       typeName = <span className='badge bg-primary'>{t('MultiSelect')}</span>;
// //     } else if (item.attType === 'Select') {
// //       typeIcon = <i className='fas fa-dot-circle text-success'></i>;
// //       typeName = <span className='badge bg-success'>{t('SingleSelect')}</span>;
// //     } else if (item.attType === 'Color') {
// //       typeIcon = <i className='fas fa-palette text-warning'></i>;
// //       typeName = <span className='badge bg-warning text-dark'>{t('Color')}</span>;
// //     } else {
// //       typeIcon = null;
// //       typeName = '';
// //     }

// //     return {
// //       name: i18n.language === 'en' ? item.name : item.name2,
// //       type: (
// //         <div className='d-flex align-items-center gap-2'>
// //           {typeIcon}
// //           {typeName}
// //         </div>
// //       ),
// //       description: item.description,
// //       action: (
// //         <>
// //           <button
// //             hidden={!HasPermission('INVAddAssignmentAttributesItems')}
// //             type='button'
// //             className='btn btn-sm btn-outline-theme me-2'
// //             data-bs-toggle='modal'
// //             data-bs-target='#assign'
// //             onClick={() => setAttribute(item)}
// //           >
// //             <i className='fas fa-lg fa-briefcase me-2'></i>
// //             {t('Items')}
// //           </button>
// //           <button
// //             hidden={!HasPermission('INVEditAttributes')}
// //             type='button'
// //             className='btn btn-sm btn-outline-theme'
// //             data-bs-toggle='modal'
// //             data-bs-target='#Upfate'
// //             onClick={() => setAttribute(item)}
// //           >
// //             <i className='fas fa-lg fa-edit me-2'></i>
// //             {t('Edit')}
// //           </button>
// //         </>
// //       )
// //     };
// //   });

// //   const titleModal = () => {
// //     return (
// //       <div className=''>
// //         {t('Items')}
// //         <span className='text-theme'>{`(${i18n.language === 'en' ? attribute?.name : attribute?.name2})`}</span>
// //       </div>
// //     );
// //   };

// //   return (
// //     <>
// //       <div>
// //         <div className='d-flex align-items-center'>
// //           <Breadcrumb
// //             BreadcrumbList={[
// //               {
// //                 name: t('Home'),
// //                link: ':moduleHome'
// //               },
// //               {
// //                 name: t('ItemAttributes'),
// //                 link: null
// //               }
// //             ]}
// //             PageName={t('ItemAttributes')}
// //           />

// //           <div className='ms-auto'>
// //             <Link
// //               hidden={!HasPermission('INVAddAttributes')}
// //               to=''
// //               className='btn me-1 btn-theme'
// //               data-bs-toggle='modal'
// //               data-bs-target='#Add'
// //             >
// //               <i className='fa fa-lg fa-plus-circle fa-fw me-1'></i>
// //               {t('NewAttribute')}
// //             </Link>
// //           </div>
// //         </div>
// //         <Card>
// //           <Loading loading={loading} error={error}>
// //             <CardBody>
// //               <NtxTable
// //                 data={tableData || []}
// //                 columns={columns}
// //                 dataPerPage={12}
// //                 theadClass=''
// //                 tableClass='table text-nowrap table-hover '
// //                 enableSearch
// //                 showRecordsSelector
// //               />
// //             </CardBody>
// //           </Loading>
// //         </Card>

// //         <ModalComponent title={t('NewAttribute')} id='Add'>
// //           {<Add />}
// //         </ModalComponent>

// //         <ModalComponent title={t('EditAttribute')} id='Upfate'>
// //           {attribute && <Update attributId={attribute.id} />}
// //         </ModalComponent>

// //         <ModalComponent title={titleModal()} id='assign' size='lg'>
// //           {attribute && <AttributeItems attributId={attribute.id} />}
// //         </ModalComponent>
// //       </div>
// //     </>
// //   );
// // };

// // export default Index;


// import { useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import ModalComponent from '@components/Modal/ModalComponent';
// import Add from './Add';
// import Loading from '@components/Shared/Loader/Loading';
// import Update from './Update';
// import useGetAttributeList from '@hooks/INV/Attributes/useGetAttributeList';
// import AttributeItems from './AttributeItems';
// import { usePermissions } from '@Helper/Permisstions/usePermissions';

// const Index = () => {
//   const { HasPermission } = usePermissions();
//   const [attribute, setAttribute] = useState<any>();
//   const [searchTerm, setSearchTerm] = useState<string>('');
//   const { t, i18n } = useTranslation();
//   const { AttributesList, error, loading } = useGetAttributeList();

//   // الحصول على الاسم المعروض بناءً على اللغة
//   const getDisplayName = (item: any): string => {
//     return i18n.language === 'en' ? item?.name : item?.name2;
//   };

//   // تصفية البيانات حسب البحث
//   const filteredAttributes = AttributesList?.filter((item: any) => {
//     if (searchTerm.trim() === '') return true;
    
//     const searchLower = searchTerm.toLowerCase();
//     const name = getDisplayName(item).toLowerCase();
//     const description = item.description?.toLowerCase();
//     const type = item.attType?.toLowerCase();
    
//     return name.includes(searchLower) || description?.includes(searchLower) || type?.includes(searchLower);
//   });

//   // دالة مسح البحث
//   const clearSearch = (): void => {
//     setSearchTerm('');
//   };

//   // الحصول على بادجة نوع السمة
//   const getAttributeTypeBadge = (attType: string) => {
//     let badgeClass = '';
//     let icon = '';
//     let text = '';

//     switch (attType) {
//       case 'Multi_Select':
//         badgeClass = 'bg-primary text-white';
//         icon = 'fas fa-check-square';
//         text = t('MultiSelect');
//         break;
//       case 'Select':
//         badgeClass = 'bg-success text-white';
//         icon = 'fas fa-dot-circle';
//         text = t('SingleSelect');
//         break;
//       case 'Color':
//         badgeClass = 'bg-warning text-dark';
//         icon = 'fas fa-palette';
//         text = t('Color');
//         break;
//       default:
//         badgeClass = 'bg-secondary text-white';
//         icon = 'fas fa-question-circle';
//         text = attType;
//     }

//     return (
//       <span className={`badge ${badgeClass} d-flex align-items-center justify-content-center`}>
//         <i className={`${icon} fa-fw me-1`}></i>
//         {text}
//       </span>
//     );
//   };

//   // الحصول على أيقونة السمة
//   const getAttributeIcon = (attType: string) => {
//     switch (attType) {
//       case 'Multi_Select':
//         return 'fas fa-check-square text-primary';
//       case 'Select':
//         return 'fas fa-dot-circle text-success';
//       case 'Color':
//         return 'fas fa-palette text-warning';
//       default:
//         return 'fas fa-tag text-theme';
//     }
//   };

//   // إحصائيات السمات
//   const totalAttributes: number = AttributesList?.length || 0;
//   const multiSelectAttributes: number = AttributesList?.filter((item: any) => item.attType === 'Multi_Select').length || 0;
//   const singleSelectAttributes: number = AttributesList?.filter((item: any) => item.attType === 'Select').length || 0;
//   const colorAttributes: number = AttributesList?.filter((item: any) => item.attType === 'Color').length || 0;

//   const breadcrumbList: any[] = [
//     {
//       name: t('Home'),
//       link: ':moduleHome'
//     },
//     {
//       name: t('ItemAttributes'),
//       link: null
//     }
//   ];

//   const titleModal = () => {
//     return (
//       <div className=''>
//         {t('Items')}
//         <span className='text-theme'>{` (${getDisplayName(attribute)})`}</span>
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('ItemAttributes')} />

//         <div className='ms-auto'>
//           <Link
//             hidden={!HasPermission('INVAddAttributes')}
//             to=''
//             className='btn me-1 btn-theme'
//             data-bs-toggle='modal'
//             data-bs-target='#Add'
//           >
//             <i className='fa fa-plus-circle fa-fw me-1'></i>
//             {t('NewAttribute')}
//           </Link>
//         </div>
//       </div>

//       {/* بطاقات الإحصائيات */}
//       <div className='row mb-4'>
//         {/* إجمالي السمات */}
//         <div className='col-md-3'>
//           <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm h-100'>
//             <CardBody className='py-3'>
//               <div className='d-flex align-items-center'>
//                 <div className='flex-shrink-0'>
//                   <i className='fas fa-tags fa-2x text-primary'></i>
//                 </div>
//                 <div className='flex-grow-1 ms-3'>
//                   <h4 className='text-primary mb-0'>{totalAttributes}</h4>
//                   <p className='text-muted mb-0'>إجمالي السمات</p>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </div>

//         {/* متعدد الاختيار */}
//         <div className='col-md-3'>
//           <Card className='bg-info bg-opacity-10 border-info border-0 shadow-sm h-100'>
//             <CardBody className='py-3'>
//               <div className='d-flex align-items-center'>
//                 <div className='flex-shrink-0'>
//                   <i className='fas fa-check-square fa-2x text-info'></i>
//                 </div>
//                 <div className='flex-grow-1 ms-3'>
//                   <h4 className='text-info mb-0'>{multiSelectAttributes}</h4>
//                   <p className='text-muted mb-0'>متعدد الاختيار</p>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </div>

//         {/* اختيار فردي */}
//         <div className='col-md-3'>
//           <Card className='bg-success bg-opacity-10 border-success border-0 shadow-sm h-100'>
//             <CardBody className='py-3'>
//               <div className='d-flex align-items-center'>
//                 <div className='flex-shrink-0'>
//                   <i className='fas fa-dot-circle fa-2x text-success'></i>
//                 </div>
//                 <div className='flex-grow-1 ms-3'>
//                   <h4 className='text-success mb-0'>{singleSelectAttributes}</h4>
//                   <p className='text-muted mb-0'>اختيار فردي</p>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </div>

//         {/* ألوان */}
//         <div className='col-md-3'>
//           <Card className='bg-warning bg-opacity-10 border-warning border-0 shadow-sm h-100'>
//             <CardBody className='py-3'>
//               <div className='d-flex align-items-center'>
//                 <div className='flex-shrink-0'>
//                   <i className='fas fa-palette fa-2x text-warning'></i>
//                 </div>
//                 <div className='flex-grow-1 ms-3'>
//                   <h4 className='text-warning mb-0'>{colorAttributes}</h4>
//                   <p className='text-muted mb-0'>سمات ألوان</p>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </div>
//       </div>

//       <Card className='mb-4'>
//         <div className='card-header d-flex justify-content-between align-items-center'>
//           <h6 className='mb-0'>
//             <i className='fas fa-tags me-2'></i>
//             سجل السمات
//           </h6>
          
//           {/* شريط البحث */}
//           <div className='d-flex align-items-center'>
//             <div className='input-group input-group-sm' style={{ width: '300px' }}>
//               <span className='input-group-text'>
//                 <i className='fas fa-search text-muted'></i>
//               </span>
//               <input
//                 type='text'
//                 className='form-control border-start-0'
//                 placeholder='ابحث باسم السمة أو الوصف...'
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//               {searchTerm && (
//                 <button
//                   className='btn btn-outline-secondary'
//                   type='button'
//                   onClick={clearSearch}
//                   title='مسح البحث'
//                 >
//                   <i className='fas fa-times'></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className='card-body p-0'>
//           <Loading loading={loading} error={error}>
//             <div className='table-responsive'>
//               <table className='table table-hover mb-0'>
//                 <thead className='table-actived fw-bold'>
//                   <tr>
//                     <th className='small'>اسم السمة</th>
//                     <th className='small'>النوع</th>
//                     <th className='small'>الوصف</th>
//                     <th className='small'>الإجراءات</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredAttributes?.length > 0 ? (
//                     filteredAttributes.map((item: any) => (
//                       <tr key={item.id}>
//                         <td className='align-middle'>
//                           <div className='d-flex align-items-center'>
//                             <i className={`${getAttributeIcon(item.attType)} fa-fw me-2`}></i>
//                             <strong>{getDisplayName(item)}</strong>
//                           </div>
//                         </td>
//                         <td className='align-middle'>
//                           {getAttributeTypeBadge(item.attType)}
//                         </td>
//                         <td className='align-middle'>
//                           {item.description ? (
//                             <span className='text-muted'>{item.description}</span>
//                           ) : (
//                             <span className='text-muted'>---</span>
//                           )}
//                         </td>
//                         <td className='align-middle'>
//                           <div className='d-flex justify-content-end'>
//                             {HasPermission('INVAddAssignmentAttributesItems') && (
//                               <button
//                                 type='button'
//                                 className='btn btn-sm btn-outline-theme me-2'
//                                 data-bs-toggle='modal'
//                                 data-bs-target='#assign'
//                                 onClick={() => setAttribute(item)}
//                                 title={t('Items')}
//                               >
//                                 <i className='fas fa-briefcase fa-fw me-1'></i>
//                                 {t('Items')}
//                               </button>
//                             )}
//                             {HasPermission('INVEditAttributes') && (
//                               <button
//                                 type='button'
//                                 className='btn btn-sm btn-outline-theme'
//                                 data-bs-toggle='modal'
//                                 data-bs-target='#Upfate'
//                                 onClick={() => setAttribute(item)}
//                                 title={t('Edit')}
//                               >
//                                 <i className='fas fa-edit fa-fw me-1'></i>
//                                 {t('Edit')}
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={4} className='text-center py-4 text-muted'>
//                         <i className='fa fa-tags fa-2x mb-2'></i>
//                         <br />
//                         {searchTerm ? 'لا توجد نتائج للبحث' : 'لا توجد سمات مسجلة'}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </Loading>
//         </div>

//         <div className='card-footer d-flex justify-content-between align-items-center'>
//           <div className='text-muted small'>
//             عرض {filteredAttributes?.length || 0} من {totalAttributes} سمة
//             {searchTerm && (
//               <span className='text-theme ms-2'>
//                 - نتائج البحث عن: "{searchTerm}"
//               </span>
//             )}
//           </div>
//           <div className='text-theme fw-bold'>
//             السمات النشطة: {totalAttributes} سمة
//           </div>
//         </div>
//       </Card>

//       <ModalComponent title={t('NewAttribute')} id='Add'>
//         <Add />
//       </ModalComponent>

//       <ModalComponent title={t('EditAttribute')} id='Upfate'>
//         {attribute && <Update attributId={attribute.id} />}
//       </ModalComponent>

//       <ModalComponent title={titleModal()} id='assign' size='lg'>
//         {attribute && <AttributeItems attributId={attribute.id} />}
//       </ModalComponent>
//     </>
//   );
// };

// export default Index;



import { useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ModalComponent from '@components/Modal/ModalComponent';
import Add from './Add';
import Loading from '@components/Shared/Loader/Loading';
import Update from './Update';
import useGetAttributeList from '@hooks/INV/Attributes/useGetAttributeList';
import AttributeItems from './AttributeItems';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import Pagination from '@components/Shared/Pagination/Pagination'; // تأكد من المسار الصحيح

const Index = () => {
  const { HasPermission } = usePermissions();
  const [attribute, setAttribute] = useState<any>();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [dataPerPage, setDataPerPage] = useState<number>(10);
  const { t, i18n } = useTranslation();
  const { AttributesList, error, loading } = useGetAttributeList();

  // الحصول على الاسم المعروض بناءً على اللغة
  const getDisplayName = (item: any): string => {
    return i18n.language === 'en' ? item?.name : item?.name2;
  };

  // تصفية البيانات حسب البحث
  const filteredAttributes = AttributesList?.filter((item: any) => {
    if (searchTerm.trim() === '') return true;
    
    const searchLower = searchTerm.toLowerCase();
    const name = getDisplayName(item).toLowerCase();
    const description = item.description?.toLowerCase();
    const type = item.attType?.toLowerCase();
    
    return name.includes(searchLower) || description?.includes(searchLower) || type?.includes(searchLower);
  });

  // دالة مسح البحث
  const clearSearch = (): void => {
    setSearchTerm('');
    setCurrentPage(1); // العودة للصفحة الأولى عند مسح البحث
  };

  // الحصول على البيانات للصفحة الحالية
  const indexOfLastItem = currentPage * dataPerPage;
  const indexOfFirstItem = indexOfLastItem - dataPerPage;
  const currentAttributes = filteredAttributes?.slice(indexOfFirstItem, indexOfLastItem) || [];

  // دالة تغيير الصفحة
  const handlePagination = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  // دالة تغيير عدد العناصر المعروضة في الصفحة
  const handleDataPerPageChange = (newDataPerPage: number) => {
    setDataPerPage(newDataPerPage);
    setCurrentPage(1); // العودة للصفحة الأولى عند تغيير عدد العناصر
  };

  // الحصول على بادجة نوع السمة
  const getAttributeTypeBadge = (attType: string) => {
    let badgeClass = '';
    let icon = '';
    let text = '';

    switch (attType) {
      case 'Multi_Select':
        badgeClass = 'bg-primary text-white';
        icon = 'fas fa-check-square';
        text = t('MultiSelect');
        break;
      case 'Select':
        badgeClass = 'bg-success text-white';
        icon = 'fas fa-dot-circle';
        text = t('SingleSelect');
        break;
      case 'Color':
        badgeClass = 'bg-warning text-dark';
        icon = 'fas fa-palette';
        text = t('Color');
        break;
      default:
        badgeClass = 'bg-secondary text-white';
        icon = 'fas fa-question-circle';
        text = attType;
    }

    return (
      <span className={`badge ${badgeClass} d-flex align-items-center justify-content-center`}>
        <i className={`${icon} fa-fw me-1`}></i>
        {text}
      </span>
    );
  };

  // الحصول على أيقونة السمة
  const getAttributeIcon = (attType: string) => {
    switch (attType) {
      case 'Multi_Select':
        return 'fas fa-check-square text-primary';
      case 'Select':
        return 'fas fa-dot-circle text-success';
      case 'Color':
        return 'fas fa-palette text-warning';
      default:
        return 'fas fa-tag text-theme';
    }
  };

  // إحصائيات السمات
  const totalAttributes: number = AttributesList?.length || 0;
  const multiSelectAttributes: number = AttributesList?.filter((item: any) => item.attType === 'Multi_Select').length || 0;
  const singleSelectAttributes: number = AttributesList?.filter((item: any) => item.attType === 'Select').length || 0;
  const colorAttributes: number = AttributesList?.filter((item: any) => item.attType === 'Color').length || 0;

  const breadcrumbList: any[] = [
    {
      name: t('Home'),
      link: ':moduleHome'
    },
    {
      name: t('ItemAttributes'),
      link: null
    }
  ];

  const titleModal = () => {
    return (
      <div className=''>
        {t('Items')}
        <span className='text-theme'>{` (${getDisplayName(attribute)})`}</span>
      </div>
    );
  };

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('ItemAttributes')} />

        <div className='ms-auto'>
          <Link
            hidden={!HasPermission('INVAddAttributes')}
            to=''
            className='btn me-1 btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#Add'
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('NewAttribute')}
          </Link>
        </div>
      </div>

      {/* بطاقات الإحصائيات */}
      <div className='row mb-4'>
        {/* إجمالي السمات */}
        <div className='col-md-3'>
          <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm h-100'>
            <CardBody className='py-3'>
              <div className='d-flex align-items-center'>
                <div className='flex-shrink-0'>
                  <i className='fas fa-tags fa-2x text-primary'></i>
                </div>
                <div className='flex-grow-1 ms-3'>
                  <h4 className='text-primary mb-0'>{totalAttributes}</h4>
                  <p className='text-muted mb-0'>إجمالي السمات</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        {/* متعدد الاختيار */}
        <div className='col-md-3'>
          <Card className='bg-info bg-opacity-10 border-info border-0 shadow-sm h-100'>
            <CardBody className='py-3'>
              <div className='d-flex align-items-center'>
                <div className='flex-shrink-0'>
                  <i className='fas fa-check-square fa-2x text-info'></i>
                </div>
                <div className='flex-grow-1 ms-3'>
                  <h4 className='text-info mb-0'>{multiSelectAttributes}</h4>
                  <p className='text-muted mb-0'>متعدد الاختيار</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        {/* اختيار فردي */}
        <div className='col-md-3'>
          <Card className='bg-success bg-opacity-10 border-success border-0 shadow-sm h-100'>
            <CardBody className='py-3'>
              <div className='d-flex align-items-center'>
                <div className='flex-shrink-0'>
                  <i className='fas fa-dot-circle fa-2x text-success'></i>
                </div>
                <div className='flex-grow-1 ms-3'>
                  <h4 className='text-success mb-0'>{singleSelectAttributes}</h4>
                  <p className='text-muted mb-0'>اختيار فردي</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        {/* ألوان */}
        <div className='col-md-3'>
          <Card className='bg-warning bg-opacity-10 border-warning border-0 shadow-sm h-100'>
            <CardBody className='py-3'>
              <div className='d-flex align-items-center'>
                <div className='flex-shrink-0'>
                  <i className='fas fa-palette fa-2x text-warning'></i>
                </div>
                <div className='flex-grow-1 ms-3'>
                  <h4 className='text-warning mb-0'>{colorAttributes}</h4>
                  <p className='text-muted mb-0'>سمات ألوان</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>

      <Card className='mb-4'>
        <div className='card-header d-flex justify-content-between align-items-center'>
          <h6 className='mb-0'>
            <i className='fas fa-tags me-2'></i>
            سجل السمات
          </h6>
          
          {/* شريط البحث وعدد العناصر */}
          <div className='d-flex align-items-center'>
            {/* اختيار عدد العناصر المعروضة */}
            <div className='me-3'>
              <select 
                className='form-select form-select-sm'
                value={dataPerPage}
                onChange={(e) => handleDataPerPageChange(Number(e.target.value))}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>

            {/* شريط البحث */}
            <div className='input-group input-group-sm' style={{ width: '300px' }}>
              <span className='input-group-text'>
                <i className='fas fa-search text-muted'></i>
              </span>
              <input
                type='text'
                className='form-control border-start-0'
                placeholder='ابحث باسم السمة أو الوصف...'
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1); // العودة للصفحة الأولى عند البحث
                }}
              />
              {searchTerm && (
                <button
                  className='btn btn-outline-secondary'
                  type='button'
                  onClick={clearSearch}
                  title='مسح البحث'
                >
                  <i className='fas fa-times'></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div className='card-body p-0'>
          <Loading loading={loading} error={error}>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='table-actived fw-bold'>
                  <tr>
                    <th className='small'>اسم السمة</th>
                    <th className='small'>النوع</th>
                    <th className='small'>الوصف</th>
                    <th className='small'>الإجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {currentAttributes.length > 0 ? (
                    currentAttributes.map((item: any) => (
                      <tr key={item.id}>
                        <td className='align-middle'>
                          <div className='d-flex align-items-center'>
                            <i className={`${getAttributeIcon(item.attType)} fa-fw me-2`}></i>
                            <strong>{getDisplayName(item)}</strong>
                          </div>
                        </td>
                        <td className='align-middle'>
                          {getAttributeTypeBadge(item.attType)}
                        </td>
                        <td className='align-middle'>
                          {item.description ? (
                            <span className='text-muted'>{item.description}</span>
                          ) : (
                            <span className='text-muted'>---</span>
                          )}
                        </td>
                        <td className='align-middle'>
                          <div className='d-flex justify-content-end'>
                            {HasPermission('INVAddAssignmentAttributesItems') && (
                              <button
                                type='button'
                                className='btn btn-sm btn-outline-theme me-2'
                                data-bs-toggle='modal'
                                data-bs-target='#assign'
                                onClick={() => setAttribute(item)}
                                title={t('Items')}
                              >
                                <i className='fas fa-briefcase fa-fw me-1'></i>
                                {t('Items')}
                              </button>
                            )}
                            {HasPermission('INVEditAttributes') && (
                              <button
                                type='button'
                                className='btn btn-sm btn-outline-theme'
                                data-bs-toggle='modal'
                                data-bs-target='#Upfate'
                                onClick={() => setAttribute(item)}
                                title={t('Edit')}
                              >
                                <i className='fas fa-edit fa-fw me-1'></i>
                                {t('Edit')}
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className='text-center py-4 text-muted'>
                        <i className='fa fa-tags fa-2x mb-2'></i>
                        <br />
                        {searchTerm ? 'لا توجد نتائج للبحث' : 'لا توجد سمات مسجلة'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Loading>
        </div>

        <div className='card-footer'>
          <Pagination
            filteredData={filteredAttributes || []}
            dataPerPage={dataPerPage}
            handlePagination={handlePagination}
            currentPage={currentPage}
          />
        </div>
      </Card>

      <ModalComponent title={t('NewAttribute')} id='Add'>
        <Add />
      </ModalComponent>

      <ModalComponent title={t('EditAttribute')} id='Upfate'>
        {attribute && <Update attributId={attribute.id} />}
      </ModalComponent>

      <ModalComponent title={titleModal()} id='assign' size='lg'>
        {attribute && <AttributeItems attributId={attribute.id} />}
      </ModalComponent>
    </>
  );
};

export default Index;